import { data } from '../../svg/Meter/data';
import { makeIcon } from '../makeIcon';

export const Meter = makeIcon(data, 'meter', 'Meter');

export default Meter;
